import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Typography } from '@packages/shared';
import { defineMessages, useIntl } from 'react-intl';

const ReviewTagsFragment = graphql(/* GraphQL */ `
  fragment ReviewTagsFragment on ReviewTags {
    proTags {
      id
      name
    }
    contraTags {
      id
      name
    }
  }
`);

const messages = defineMessages({
  advantagesLabel: {
    id: 'review.advantages.label',
    defaultMessage: 'Vorteile:',
  },
  drawbacksLabel: {
    id: 'review.drawbacks.label',
    defaultMessage: 'Nachteile:',
  },
});

type ReviewTagsProps = {
  // pro and contra review tags | __typename ReviewTags
  reviewTagsData: FragmentType<typeof ReviewTagsFragment>;
};

/**
 * Pro and contra review tags displayed in a customer review
 */
export const ReviewTags = ({ reviewTagsData }: ReviewTagsProps) => {
  const { proTags, contraTags } = getFragmentData(ReviewTagsFragment, reviewTagsData);
  const { formatMessage } = useIntl();

  return (
    <>
      {proTags && proTags.length > 0 && (
        <Typography variant="body2">
          {`${formatMessage(messages.advantagesLabel)} ${proTags.map((t) => t.name).join(', ')}`}
        </Typography>
      )}
      {contraTags && contraTags.length > 0 && (
        <Typography variant="body2">{`${formatMessage(messages.drawbacksLabel)} ${contraTags
          .map((t) => t.name)
          .join(', ')}`}</Typography>
      )}
    </>
  );
};
